import {useEffect, useState} from "react";
import {findWebshopOrdersWithPagination} from "../api/apiClient";

export const useWebshopOrders = (page, reloadTrigger) => {
    const [webshopOrders, setWebshopOrders] = useState([]);
    const [webshopOrdersPagination, setWebshopOrdersPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const webshopOrdersWithPagination = findWebshopOrdersWithPagination(page, abortController.signal);

        webshopOrdersWithPagination
            .then(
                (data) => {
                    const orders = data.orders;
                    const pagination = data.pagination;

                    setWebshopOrders(orders)
                    setWebshopOrdersPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, reloadTrigger]);

    return {webshopOrders : webshopOrders, webshopOrdersPagination : webshopOrdersPagination};
};
